import React, { useState, useEffect } from "react";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import emailjs from "@emailjs/browser";

const FreeAudit = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    website: "",
    service: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    emailjs.init("mAR5qnphilAc8abIl");
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      await emailjs.send(
  "service_89v7jti",
  "template_whdk8pt",
  {
    name: formData.name,
    email: formData.email,
    phone: formData.phone || "Not provided",
    company: formData.company || "Not provided",
    website: formData.website || "Not provided",
    service: formData.service || "Not specified",
    message: formData.message || "No message",
  }
);

      setFormData({
        name: "",
        email: "",
        phone: "",
        company: "",
        website: "",
        service: "",
        message: "",
      });
      setSubmitted(true);
      setTimeout(() => setSubmitted(false), 5000);
    } catch (err) {
      console.error("Email send failed:", err);
      setError("Failed to send request. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="overflow-hidden">
      {/* Header */}
      <section className="pt-32 pb-8 md:pt-40 md:pb-12">
        <div className="max-w-[1320px] mx-auto px-6">
          <p
            className="text-[#F26522] text-[15px] font-semibold mb-2"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Urban Hunter
          </p>
          <h1
            className="text-[40px] md:text-[56px] font-bold leading-tight mb-4"
            style={{ fontFamily: "'Poppins', sans-serif", color: "#1B1B3A" }}
          >
            Free Audit
          </h1>
          <p
            className="text-[#555] text-[16px] max-w-[600px] leading-relaxed"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Get a comprehensive, no-obligation audit of your current digital marketing strategy. Our experts will analyze your efforts and provide actionable insights.
          </p>
        </div>
      </section>

      {/* Form */}
      <section className="pb-16 md:pb-24">
        <div className="max-w-[1320px] mx-auto px-6">
          <div className="flex flex-col lg:flex-row gap-12">
            {/* Form */}
            <div className="lg:w-2/3">
              {submitted ? (
                <div className="bg-[#F0FFF4] border border-green-200 rounded-2xl p-12 text-center">
                  <CheckCircle2 size={48} className="text-green-500 mx-auto mb-4" />
                  <h3
                    className="text-[24px] font-bold mb-3"
                    style={{ fontFamily: "'Poppins', sans-serif", color: "#1B1B3A" }}
                  >
                    Thank you for your interest!
                  </h3>
                  <p
                    className="text-[#555] text-[16px]"
                    style={{ fontFamily: "'Poppins', sans-serif" }}
                  >
                    We'll get back to you within 24 hours with your free audit report.
                  </p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-6">
                  {error && (
                    <div className="bg-red-50 border border-red-200 rounded-2xl p-4 text-center">
                      <p className="text-red-600 text-[14px]" style={{ fontFamily: "'Poppins', sans-serif" }}>
                        {error}
                      </p>
                    </div>
                  )}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-[13px] font-semibold text-[#1B1B3A] mb-2 uppercase tracking-wider" style={{ fontFamily: "'Poppins', sans-serif" }}>
                        Full Name *
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        className="w-full px-5 py-4 rounded-xl border border-gray-200 text-[15px] outline-none focus:border-[#F26522] transition-colors"
                        style={{ fontFamily: "'Poppins', sans-serif" }}
                        placeholder="John Doe"
                      />
                    </div>
                    <div>
                      <label className="block text-[13px] font-semibold text-[#1B1B3A] mb-2 uppercase tracking-wider" style={{ fontFamily: "'Poppins', sans-serif" }}>
                        Email Address *
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        className="w-full px-5 py-4 rounded-xl border border-gray-200 text-[15px] outline-none focus:border-[#F26522] transition-colors"
                        style={{ fontFamily: "'Poppins', sans-serif" }}
                        placeholder="john@company.com"
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-[13px] font-semibold text-[#1B1B3A] mb-2 uppercase tracking-wider" style={{ fontFamily: "'Poppins', sans-serif" }}>
                        Phone Number
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        className="w-full px-5 py-4 rounded-xl border border-gray-200 text-[15px] outline-none focus:border-[#F26522] transition-colors"
                        style={{ fontFamily: "'Poppins', sans-serif" }}
                        placeholder="+91-99600-37935"
                      />
                    </div>
                    <div>
                      <label className="block text-[13px] font-semibold text-[#1B1B3A] mb-2 uppercase tracking-wider" style={{ fontFamily: "'Poppins', sans-serif" }}>
                        Company Name
                      </label>
                      <input
                        type="text"
                        name="company"
                        value={formData.company}
                        onChange={handleChange}
                        className="w-full px-5 py-4 rounded-xl border border-gray-200 text-[15px] outline-none focus:border-[#F26522] transition-colors"
                        style={{ fontFamily: "'Poppins', sans-serif" }}
                        placeholder="Your Company"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-[13px] font-semibold text-[#1B1B3A] mb-2 uppercase tracking-wider" style={{ fontFamily: "'Poppins', sans-serif" }}>
                      Website URL
                    </label>
                    <input
                      type="url"
                      name="website"
                      value={formData.website}
                      onChange={handleChange}
                      className="w-full px-5 py-4 rounded-xl border border-gray-200 text-[15px] outline-none focus:border-[#F26522] transition-colors"
                      style={{ fontFamily: "'Poppins', sans-serif" }}
                      placeholder="https://www.yourwebsite.com"
                    />
                  </div>

                  <div>
                    <label className="block text-[13px] font-semibold text-[#1B1B3A] mb-2 uppercase tracking-wider" style={{ fontFamily: "'Poppins', sans-serif" }}>
                      Service Interested In
                    </label>
                    <select
                      name="service"
                      value={formData.service}
                      onChange={handleChange}
                      className="w-full px-5 py-4 rounded-xl border border-gray-200 text-[15px] outline-none focus:border-[#F26522] transition-colors bg-white"
                      style={{ fontFamily: "'Poppins', sans-serif" }}
                    >
                      <option value="">Select a service</option>
                      <option value="google-ads">Google Ads</option>
                      <option value="social-media-ads">Social Media Ads</option>
                      <option value="seo">Search Engine Optimization</option>
                      <option value="ecommerce">E-Commerce Marketing</option>
                      <option value="programmatic">Programmatic Advertising</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-[13px] font-semibold text-[#1B1B3A] mb-2 uppercase tracking-wider" style={{ fontFamily: "'Poppins', sans-serif" }}>
                      Message
                    </label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      rows={5}
                      className="w-full px-5 py-4 rounded-xl border border-gray-200 text-[15px] outline-none focus:border-[#F26522] transition-colors resize-none"
                      style={{ fontFamily: "'Poppins', sans-serif" }}
                      placeholder="Tell us about your business and goals..."
                    />
                  </div>

                  <button
                    type="submit"
                    disabled={loading}
                    className="inline-flex items-center gap-2 bg-[#1B1B3A] text-white px-10 py-4 rounded-full text-[14px] font-semibold tracking-wider uppercase hover:bg-[#2a2a5a] transition-colors duration-300 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                    style={{ fontFamily: "'Poppins', sans-serif" }}
                  >
                    {loading ? "Sending..." : "Submit Request"}
                    {!loading && <ArrowRight size={16} />}
                  </button>
                </form>
              )}
            </div>

            {/* Right Sidebar */}
            <div className="lg:w-1/3">
              <div className="bg-[#F8F6FF] rounded-2xl p-8 sticky top-32">
                <h3
                  className="text-[20px] font-bold mb-4"
                  style={{ fontFamily: "'Poppins', sans-serif", color: "#1B1B3A" }}
                >
                  What you'll get:
                </h3>
                <ul className="space-y-4">
                  {[
                    "Comprehensive digital audit report",
                    "Competitor analysis overview",
                    "Actionable recommendations",
                    "Performance benchmarks",
                    "Custom growth strategy outline",
                    "30-minute consultation call",
                  ].map((item, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <CheckCircle2 size={18} className="text-[#F26522] mt-0.5 flex-shrink-0" />
                      <span
                        className="text-[#444] text-[14px]"
                        style={{ fontFamily: "'Poppins', sans-serif" }}
                      >
                        {item}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FreeAudit;
